

export default [
    // local Storage Plugin
    // IndexedDB Plugin
]